import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouse(agro_exporter_id, packing_house_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_packing_house_certification/${agro_exporter_id}/fetch_packing_house/${packing_house_id}`
    );
  },
  fetchPackingHouseCertifications(agro_exporter_id, packing_house_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_packing_house_certification/${agro_exporter_id}/fetch_packing_house_certifications/${packing_house_id}`
    );
  },
  fetchPackingHouseCertification(
    agro_exporter_id,
    packing_house_id,
    packing_house_certification_id
  ) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_packing_house_certification/${agro_exporter_id}/fetch_packing_house_certification/${packing_house_id}/${packing_house_certification_id}`
    );
  },
  fetchCertificationReviews(agro_exporter_id, packing_house_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_packing_house_certification/${agro_exporter_id}/fetch_certification_reviews/${packing_house_id}`
    );
  },
  fetchCertifications(agro_exporter_id, packing_house_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_packing_house_certification/${agro_exporter_id}/fetch_certifications/${packing_house_id}`
    );
  },
  create(agro_exporter_id, packing_house_id, packing_house_certification) {
    let formData = new FormData();
    formData.append(
      "packing_house_certification[certification_code]",
      packing_house_certification.certification_code
    );
    formData.append(
      "packing_house_certification[expiration_date]",
      packing_house_certification.expiration_date
    );
    formData.append(
      "packing_house_certification[certification_id]",
      packing_house_certification.certification_id
    );
    formData.append(
      "packing_house_certification[renewal_date]",
      packing_house_certification.renewal_date
    );
    formData.append(
      "packing_house_certification[active]",
      packing_house_certification.active
    );
    if (packing_house_certification.certificate_file) {
      formData.append(
        "packing_house_certification[certificate_file]",
        packing_house_certification.certificate_file
      );
    }
    return RequesterV1.post(
      `agro_exporter/certifications/providers/manage_packing_house_certification/${agro_exporter_id}/create/${packing_house_id}`,
      formData
    );
  },
  update(
    agro_exporter_id,
    packing_house_id,
    packing_house_certification_id,
    packing_house_certification
  ) {
    let formData = new FormData();
    formData.append(
      "packing_house_certification[certification_code]",
      packing_house_certification.certification_code
    );
    formData.append(
      "packing_house_certification[expiration_date]",
      packing_house_certification.expiration_date
    );
    formData.append(
      "packing_house_certification[certification_id]",
      packing_house_certification.certification_id
    );
    formData.append(
      "packing_house_certification[renewal_date]",
      packing_house_certification.renewal_date
    );
    formData.append(
      "packing_house_certification[active]",
      packing_house_certification.active
    );
    if (packing_house_certification.certificate_file) {
      formData.append(
        "packing_house_certification[certificate_file]",
        packing_house_certification.certificate_file
      );
    }
    return RequesterV1.post(
      `agro_exporter/certifications/providers/manage_packing_house_certification/${agro_exporter_id}/update/${packing_house_id}/${packing_house_certification_id}`,
      formData
    );
  },
  destroy(agro_exporter_id, packing_house_id, packing_house_certification_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_packing_house_certification/${agro_exporter_id}/destroy/${packing_house_id}/${packing_house_certification_id}`
    );
  },
  downloadCertificateFile(
    agro_exporter_id,
    organization_id,
    packing_house_certification_id
  ) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_packing_house_certification/${agro_exporter_id}/download_certificate_file/${organization_id}/${packing_house_certification_id}`,
      { responseType: "blob" }
    );
  }
};
